import { memo, useMemo } from "react";

import {
  ThemeIcon,
  Center,
  Image,
  UnstyledButton,
  Tooltip
} from "@mantine/core";

import { getAttachmentIcon } from "modules/chat/components/ChatInput/ChatInputFile";

import classes from "./styles.module.css";

type ConversationFileProps = {
  url: string;
  name?: string;
  fileType: string;
};

const ConversationFile = (props: ConversationFileProps) => {
  const { url, name, fileType } = props;

  const icon = useMemo(() => getAttachmentIcon(fileType), [fileType]);

  const fileName = useMemo(() => name || url.split("/").pop(), [name, url]);

  return (
    <Tooltip label={fileName}>
      <UnstyledButton
        className={classes.file}
        component="a"
        href={url}
        target="_blank"
      >
        {fileType.startsWith("image/") ? (
          <Image src={url} w="100%" h="100%" />
        ) : (
          <Center w="100%" h="100%">
            <ThemeIcon>{icon}</ThemeIcon>
          </Center>
        )}
      </UnstyledButton>
    </Tooltip>
  );
};

export default memo(ConversationFile);
